import React, { useEffect, useState } from "react"
import { envAwarePost } from "../../util/util";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button"
import { useSelector } from "react-redux";
import classes from "./Settings.module.css"


function Workouts() {

  const [shouldCopyExerciseNote, setShouldCopyExerciseNote]=useState(1)

  const userId = useSelector(state => state.users.current_user.user_id_number);

  useEffect(()=> {
    envAwarePost('api/user/api.php', {
      action: 'getShouldCopyExerciseNote',
      user_id_number: userId
    }).then((res) => {
      setShouldCopyExerciseNote(res.data)
    })
  },[])

  const handleChangePermission =()=> {
    let should_copy;
    if(parseInt(shouldCopyExerciseNote) ===1){
      should_copy = 0
      setShouldCopyExerciseNote(0)
    } else {
      should_copy = 1
      setShouldCopyExerciseNote(1)
    }
    envAwarePost('api/user/api.php', {
      action: 'updateShouldCopyExerciseNote',
      should_copy: should_copy,
      user_id_number: userId
    })
  }

  return (
      <Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
          <Card.Body>
              <h4>Workout Settings</h4>
              <p>When adding an exercise to a workout, the exercise's notes are copied into the workout's exercise notes. </p>
              <hr class="mt-1" />
              <Row key="" className="d-flex align-items-center justify-content-center mb-5">
                  <Col >
                      <div className="d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                          Automatically add exercise notes:
                      </div>
                  </Col>
                  <Col >
                      <Form.Group className="mb-0">
                          <Form.Check onChange={() => handleChangePermission()}
                              checked={parseInt(shouldCopyExerciseNote) ===1} type="checkbox" className="custom-control custom-checkbox" >
                          </Form.Check >
                      </Form.Group>
                  </Col>
              </Row>
          </Card.Body>
      </Card>
  )
}

export default Workouts